import { render, staticRenderFns } from "./DepartmentsField.vue?vue&type=template&id=52f7d462&scoped=true"
import script from "./DepartmentsField.vue?vue&type=script&lang=js"
export * from "./DepartmentsField.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsField.vue?vue&type=style&index=0&id=52f7d462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f7d462",
  null
  
)

export default component.exports